import { useState, useContext } from 'react'
import styled from '@emotion/styled'
import { Box, Text, Flex } from 'rebass'
import { MediaQueries as Mq } from '../../styles/settings/theme'
import { DataContext } from '../../contexts/dataContext'
import IntroTimeLine from '../organisms/IntroTimeLine'
import { TransparentButton, BigRedButton } from '../atoms/Buttons'
import Arrows from '../atoms/Arrows'
import FooterBar from '../atoms/FooterBar'
import { lang } from '../../utils/lang'
import { getFaNum } from '../../utils/helpers'
import { useHistory } from 'react-router-dom'
import { BASE_URL } from '../../utils/constants'

const FlexContainer = styled(Flex)`
  flex-direction: column;
  width: 100%;
  padding-bottom: 0;
  justify-content: space-between;
  ${Mq.sm} {
    padding-bottom: 1rem;
    width: 40%;
  }
`

const IntroTitle = styled(Text)`
  font-family: ${(props) => props.theme.fonts.condensed};
  font-size: 2.25rem;
  font-weight: 700;
  line-height: 1.15;
  text-transform: uppercase;
  ${Mq.xs} {
    font-size: 2.9rem;
  }
`
// const IntroSubTitle = styled(Text)`
//   font-size: 1.15rem;
//   font-weight: 700;
//   line-height: 1.3;
//   ${Mq.xs} {
//     font-size: 1.25rem;
//   }

const IntroText = styled(Text)`
  height: 28rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  padding-top: 1rem;
  //overflow-y: auto;
  ${Mq.md} {
    height: auto;
  }
  a {
    &:link {
      color: ${(props) => props.theme.colors.white};
      text-decoration: underline;
    }
    &:hover {
      color: ${(props) => props.theme.colors.aqua};
    }
  }
`
const Content = styled(Box)`
  width: 100%;
  height: 100%;
  overflow-y: ${(props) => (props.show ? 'hidden' : 'auto')};
  position: relative;
  padding: 0 0.75rem;
`
// #13222a
const Gradient = styled(Box)`
  background-image: linear-gradient(to bottom, transparent, #13222a);
  width: 100%;
  height: 3rem;
  position: sticky;
  bottom: -1px;
  text-align: center;
  padding-top: 3rem;
  display: ${(props) => (props.show ? 'block' : 'none')};
`
const ReadMore = styled(Text)`
  color: ${(props) => props.theme.colors.white};
  //background-color: #13222a;
  font-family: ${(props) => props.theme.fonts.condensed};
  font-size: 1rem;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  display: ${(props) => (props.show ? 'block' : 'none')};
  cursor: pointer;
`
const MobileFlex = styled(Flex)`
  ${Mq.sm} {
    display: none;
  }
`
const MobileBox = styled(Box)`
  ${Mq.sm} {
    display: none;
  }
`
const IntroGraphicTitle = styled(Text)`
  font-family: ${(props) => props.theme.fonts.condensed};
  font-size: 1.5rem;
  font-weight: 400;
  padding-bottom: 2rem;
  line-height: 1.15;
  span {
    font-size: 2rem;
    font-weight: 700;
    color: ${(props) => props.theme.colors.red};
  }
  ${Mq.sm} {
    display: none;
  }
`
const BottomBoxText = styled(Text)`
  font-family: ${(props) => props.theme.fonts.condensed};
  font-size: 1.1rem;
  font-weight: 300;
  line-height: 1.17;
  //text-align: center;
`
const IntroInformation = () => {
  const { formattedData, years, setIntro, ui } = useContext(DataContext) //for added components on mobile
  const [show, setShow] = useState(true)
  const dir = ui === 'en' ? 'ltr' : 'rtl'
  const uiLang = ui === 'fa' ? 'fa/' : ''
  const history = useHistory()

  // if (loading) {
  //   return <p>Loading</p>
  // }
  // if (error) {
  //   return <div>{error}</div>
  // }
  const handleClick = () => {
    setIntro('closed')
    const currParam = new URLSearchParams(window.location.search)
    currParam.set('intro', 'closed')
    history.push(`?${currParam.toString()}`)
  }
  return (
    <FlexContainer>
      <Content show={show}>
        <IntroTitle dir={dir}> {lang[ui]['Title']}</IntroTitle>
        {/* <IntroSubTitle my={3} dir={dir}>
          {lang[ui]['Subtitle']}
        </IntroSubTitle> */}

        <MobileFlex justifyContent="center" my={6} dir={dir}>
          <BigRedButton onClick={handleClick} ui={ui}>
            <Flex>
              <Box>{lang[ui]['Explore']}</Box>
              <Box mt={'2px'} ml={ui === 'en' ? 3 : 0} mr={ui === 'en' ? 0 : 3}>
                <Arrows
                  color="white"
                  width="12px"
                  height="16px"
                  flip={ui === 'fa'}
                />
              </Box>
            </Flex>
          </BigRedButton>
        </MobileFlex>

        {formattedData && years && (
          <>
            <IntroGraphicTitle dir={dir}>
              {lang[ui]['AtLeast']}
              <span>
                {' '}
                {ui === 'en'
                  ? formattedData.length
                  : getFaNum(formattedData.length)}
              </span>{' '}
              {lang[ui]['Quantity']}{' '}
              <span>
                {' '}
                {ui === 'en'
                  ? years[1] - years[0] + 1
                  : getFaNum(years[1] - years[0] + 1)}
              </span>{' '}
              {lang[ui]['Years']}
            </IntroGraphicTitle>

            <MobileFlex mb={8}>
              <IntroTimeLine data={formattedData} years={years} ui={ui} />
            </MobileFlex>
          </>
        )}

        <IntroText>
          <p dir={dir}>{lang[ui]['Intro1']}</p>
          <br></br>
          <p dir={dir}>{lang[ui]['Intro2']}</p>
          <br></br>
          <p dir={dir}>{lang[ui]['Intro3']}</p>
          <br></br>
          {ui === 'en' ? (
            <p dir={dir}>
              To read about our methodology, please click&nbsp;
              <a
                href={`${BASE_URL}/projects/ejk/detail`}
                target="_blank"
                rel="noreferrer"
              >
                here
              </a>
              .
            </p>
          ) : (
            <p dir={dir}>
              برای مطالعه روش‌شناسی&nbsp;
              <a
                href={`${BASE_URL}/fa/projects/ejk/detail`}
                target="_blank"
                rel="noreferrer"
              >
                اینجا
              </a>
              &nbsp;را کلیک کنید.
            </p>
          )}
        </IntroText>
        <Gradient show={show} />
      </Content>
      <ReadMore onClick={() => setShow(false)} show={show} dir={dir}>
        + {lang[ui]['Read']}
      </ReadMore>

      <MobileFlex flexDirection="column" alignItems="center" my={8} dir={dir}>
        <BottomBoxText mb={2} ml={1}>
          {lang[ui]['Contribute']}
        </BottomBoxText>
        <TransparentButton border="true" ui={ui}>
          <a
            href={`${BASE_URL}/${uiLang}memorial/add`}
            target="_blank"
            rel="noreferrer"
          >
            <Flex>
              <Box> {lang[ui]['Add']}</Box>
              <Box mt={'2px'} ml={ui === 'en' ? 3 : 0} mr={ui === 'en' ? 0 : 3}>
                <Arrows
                  color="white"
                  width="16px"
                  height="19px"
                  flip={ui === 'fa'}
                />
              </Box>
            </Flex>
          </a>
        </TransparentButton>
      </MobileFlex>

      <MobileBox>
        <FooterBar />
      </MobileBox>
    </FlexContainer>
  )
}
export default IntroInformation
